import { authorization } from 'Module/Auth/Auth'
import { useWrappedPosthog } from 'Components/PostHogProvider/hooks'
import { AnalyticsEventEmitter } from 'Utils/Analytics/AnalyticsEventEmitter'

const usePosthogAnalyticsIntegrations = () => {
  const posthog = useWrappedPosthog()

  const emitAnalyticsEvent = (eventName, additionalPayload = {}) => {
    const user = authorization.getUser()
    const eventEmitter = new AnalyticsEventEmitter(posthog)
    eventEmitter.run({
      eventName,
      userId: user.id,
      clientName: user.client.name,
      additionalPayload: {
        clientId: user.client.id.toString(),
        page: 'Integrations',
        ...additionalPayload,
      },
    })
  }

  return { emitAnalyticsEvent }
}

export default usePosthogAnalyticsIntegrations
